import { timeStringToMilliseconds } from '@lib/utils/time';

export function getWrapupTimingData(data: {
  startedTimestamp: string;
  elapsedTime: string;
  remainingTime: string;
}): {
  timestamp: string;
  elapsedTime: string;
  remainingTime: string;
  wrapupAllowedMs: number;
} {
  const timestamp = data.startedTimestamp;
  const elapsedTime = data?.elapsedTime;
  const remainingTime = data?.remainingTime;
  const wrapupAllowedMs =
    (timeStringToMilliseconds(remainingTime) ?? 0) +
    (timeStringToMilliseconds(elapsedTime) ?? 0);

  return {
    timestamp,
    elapsedTime,
    remainingTime,
    wrapupAllowedMs,
  };
}
